import {GET_SIDEBAR_CONTENT, SIDEBAR_CONTENT_LOADING, GET_PAGE_CONTENT, PAGE_CONTENT_LOADING} from './types';

const initialState = {
    sidebar: [],
    sidebarLoading: false,
    pages: [],
    pageLoading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SIDEBAR_CONTENT_LOADING:
            return {
                ...state,
                sidebarLoading: true
            };
        case GET_SIDEBAR_CONTENT:
            return {
                ...state,
                sidebar: {
                    ...state.sidebar,
                    [action.slug]: action.payload,
                },
                sidebarLoading: false
            };
        case PAGE_CONTENT_LOADING:
            return {
                ...state,
                pageLoading: true
            };
        case GET_PAGE_CONTENT:
            return {
                ...state,
                pages: {
                    ...state.pages,
                    [action.slug]: action.payload,
                },
                pageLoading: false
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/features/Content/reducers.js